import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Form} from 'react-bootstrap'
import {Auth, LoadingComponent} from 'recupero-comunes'
import {useFormik} from 'formik'
import {validationSchemas} from '../../common/validation-Schemas-atender-solicitud'
import Formulario from './formulario'
import { configuracionFormAction29, obtenerComboAprobacion, obtenerDatosSolicitudDescuento, postProcesarAtender } from '../../store/actions/atender-solicitud'

const AtenderSolicitud = () => {

    const [loading, setLoading]=useState(false)
    const {rutUsuario} = Auth.currentUser()
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer)
    const {llaves} = data_encargado
    const [showToast, setShowToast] = useState(false);
    const handleShowToast = () => setShowToast(true)
    const dispatch = useDispatch()
    const [isRechaza, setIsRechaza] = useState(false)
    const [isAjustado, setIsAjustado] = useState(false)
    const [montoNetoCompara, setMontoNetoCompara] = useState('')
    const data_antender = useSelector((state) => state.atenderSolicitudReducer)
    const {datosSolicitudDescuento,comboAprobacion} = data_antender
    const [montoAjustadoNoFormat, setMontoAjustadoNoFormat ]=useState('')

    useEffect(() => {
        if(llaves){ 
        setLoading(true)
         let query = Buffer.from(JSON.stringify({
             rutcia: llaves && llaves['idOrgCaso'],
             idform: 29
         })).toString('base64')
         dispatch(configuracionFormAction29(query))
         .then(()=>{
            let query = Buffer.from(JSON.stringify({
                "idCaso": llaves && llaves["idCaso"],
                "idImplicado": llaves && llaves["idImplicado"]
            })).toString('base64')
            dispatch(obtenerDatosSolicitudDescuento(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 248})).toString('base64')
            dispatch(obtenerComboAprobacion(query))
         })
         .then(()=>setLoading(false))
        }
     }, [dispatch,llaves])
    
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": '',
            "idOrganizacion": '',
            "idSolGestion":'',  
            "estadoSolicitud": '',
            "glosaEstadoSolictud": '',
            "porcAjustado":'',
            "montoAjustado": '',
            "comentario": '',
            "idUsuario": '',
             
        },
        validationSchema: validationSchemas(isRechaza, isAjustado,montoNetoCompara),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }

            dataForm['idCaso'] = llaves && llaves['idCaso']
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
            dataForm['idUsuario'] =rutUsuario && rutUsuario
            dataForm['glosaEstadoSolictud'] = comboAprobacion && comboAprobacion.comboAprobacion.filter(c=>c.id=== parseInt(dataForm['estadoSolicitud']))[0].nombre
            dataForm['idSolGestion'] =datosSolicitudDescuento &&
            datosSolicitudDescuento.datosSolicitudDescuento[0]['idSolicitud']

            let estado = parseInt(dataForm['estadoSolicitud']);
            switch(estado) {
                case 248001://Aprobado
                    dataForm['montoAjustado'] = datosSolicitudDescuento && datosSolicitudDescuento.datosSolicitudDescuento[0]['montoPropuestoSolDcto'];
                    break;
                case 248002://Ajustado
                    dataForm['montoAjustado'] = montoAjustadoNoFormat;
                    break;
                case 248003://Rechazado
                    dataForm['montoAjustado'] = 0;
                    break;
            }
            dispatch(postProcesarAtender(dataForm))
            handleShowToast()
        }
    })
    return (
        <div>
            <LoadingComponent show={loading}/>
            <Form onSubmit={
                formik.handleSubmit
            }>
                <Formulario formik={formik} setIsRechaza={setIsRechaza} setMontoAjustadoNoFormat={setMontoAjustadoNoFormat}
                    setIsAjustado={setIsAjustado}
                    showToast={showToast}
                    setShowToast={setShowToast}
                    loading={loading}
                    setMontoNetoCompara={setMontoNetoCompara}
                />
            </Form>
        </div>
    )
}
export default AtenderSolicitud
